import React, { Suspense, lazy, useState, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import FooterContacto from './components/FooterContacto';
import OptimizedImage from './components/OptimizedImage';
import PreloadImages from './components/PreloadImages';
import './App.css';
import './styles/main.css';
import './styles/OptimizedImage.css';

// Lazy loading de componentes
const Inicio = lazy(() => import('./pages/Inicio'));
const Cursos = lazy(() => import('./pages/Cursos'));
const Eterite = lazy(() => import('./pages/Eterite'));
const Acerca = lazy(() => import('./pages/Acerca'));
const Quienes = lazy(() => import('./pages/Quienes'));
const AgenteIA = lazy(() => import('./pages/AgenteIA'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const nav = document.querySelector('.site-nav');
      const menuToggle = document.querySelector('.menu-toggle');
      
      if (isMenuOpen && nav && !nav.contains(event.target) && !menuToggle.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, closeMenu]);

  return (
    <Router>
      <div className="App">
        <PreloadImages />
        <header className="site-header">
          <Link to="/" className="logo-link">
            <OptimizedImage 
              src={process.env.PUBLIC_URL + '/assets/logo.png'} 
              alt="AITher Logo" 
              className="site-logo"
              width={110}
              height={30}
              sizes="(max-width: 768px) 120px, 175px"
              fixedContainer={true}
            />
          </Link>
          <button 
            className="menu-toggle" 
            onClick={toggleMenu} 
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            ☰
          </button>
          <nav className={`site-nav ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/agenteIA" className="nav-link" onClick={closeMenu}>Agentes IA</Link>
            <Link to="/cursos" className="nav-link" onClick={closeMenu}>Cursos</Link>
            <Link to="/eterite" className="nav-link" onClick={closeMenu}>Eterite</Link>
            <Link to="/acerca" className="nav-link" onClick={closeMenu}>Acerca de AITher</Link>
            <Link to="/quienes" className="nav-link" onClick={closeMenu}>Quiénes somos</Link>
          </nav>
        </header>
        <main>
          <Suspense fallback={<div className="loading">Cargando...</div>}>
            <Routes>
              <Route path="/" element={<Inicio />} />
              <Route path="/cursos" element={<Cursos />} />
              <Route path="/eterite" element={<Eterite />} />
              <Route path="/acerca" element={<Acerca />} />
              <Route path="/quienes" element={<Quienes />} />
              <Route path="/agenteIA" element={<AgenteIA />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <FooterContacto />
      </div>
    </Router>
  );
}

export default App; 